import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Icon } from "@/lib/ui";
import { Loader2 } from "lucide-react";
import { AuthScaffold, Field } from "@/pages/Login";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next");
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register({ ...form, email: form.email.trim() });
      toast.success("Account created!");
      nav(next || "/app", { replace: true });
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthScaffold title="Create account" subtitle="Start protecting your belongings in minutes.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Full name" value={form.name} onChange={set("name")} testid="register-name" placeholder="Akash Sharma" />
        <Field label="Email" value={form.email} onChange={set("email")} type="email" testid="register-email" placeholder="you@example.com" />
        <Field label="Mobile number" value={form.phone} onChange={set("phone")} testid="register-phone" placeholder="+91 98765 43210" />
        <Field label="Password" value={form.password} onChange={set("password")} type="password" testid="register-password" placeholder="Min 6 characters" />
        <button data-testid="register-submit" disabled={busy} className="tap w-full h-14 rounded-full bg-primary text-primary-foreground font-bold flex items-center justify-center gap-2 disabled:opacity-60">
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <>Create account <Icon name="ArrowRight" className="w-4 h-4" /></>}
        </button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center">
        Already have an account? <Link to={`/login${next ? `?next=${next}` : ""}`} className="font-semibold text-foreground underline">Log in</Link>
      </p>
    </AuthScaffold>
  );
}
